import { useCallback } from "react";

import { Countly } from "/util/countly";
import { CountlyKey } from "/util/countly/types";

export const useAuthAnalytics = () => {
  const recordAuthEvent = useCallback((key: CountlyKey) => {
    Countly.addEvent({
      key,
      segmentation: {
        auth: false, // Always false since this is pre-auth
      },
    });
  }, []);

  return {
    recordAuthEvent,
  };
};

export default useAuthAnalytics;
